import React from "react"
import TitleSection from "../title-section";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import './InterestLinks.scss'

const InterestLinks = (props : ReferenciaContenido) => {
    const blockName: string = "m-interest-links";

    return(
        <section className={blockName}>
            <div className={`${blockName}__information`}>
                <TitleSection title={props.tituloGeneral} />
                {props.descripcion && documentToReactComponents(props.descripcion.json)}
            </div>
            <ul className={`${blockName}__link-list`}>
                {props.etiquetasArticulo.map((link)=>
                    <li className={`${blockName}__link-item ${props.tituloSeccion}`}>
                        <a href={link.split("|")[1]} target="_blank">
                            <figure>
                                <img src={props.imagenPrincipal.file.url}/>
                            </figure>
                            <span>{link.split("|")[0]}</span>
                            <img src={props.listaImagenes[0].file.url}/>
                        </a>
                    </li>
                )}
            </ul>
        </section>
    );
};

export default InterestLinks;